import apiClient from '@shared/api/apiClient';

/**
 * 회사 목록 조회 API
 * - 로그인된 사용자만 접근 가능 (인증 필요)
 * - 서버에서 회사 리스트를 조회하고 반환함
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getCompanyList() {
  // 인증이 필요한 요청이므로 withAuth 옵션을 true로 설정
  const response = await apiClient.get('/v1/users/companies', { withAuth: true });
  return response.data;
}

/**
 * 직급 리스트 조회 API
 * - 로그인된 사용자만 접근 가능 (인증 필요)
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getRankList() {
  const response = await apiClient.get('/v1/organizations/ranks', { withAuth: true });
  return response.data;
}

/**
 * 직책 리스트 조회 API
 * - 로그인된 사용자만 접근 가능 (인증 필요)
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getPositionList() {
  const response = await apiClient.get('/v1/organizations/positions', { withAuth: true });
  return response.data;
}

export { getPositionList, getRankList };
export default getCompanyList;
/**
 * 회사 수정 API
 * - 인증 필요
 * - 회사명 / 회사 닉네임 / 대표자 변경
 *
 * @param {Object} payload
 * @param {number|string} payload.companyCode - 회사 코드
 * @param {string} payload.ceoEnumber - 대표자 사번
 * @param {string} payload.companyName - 회사명
 * @param {string} payload.companyNick - 회사 닉네임
 *
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export async function updateCompany(payload) {
  const response = await apiClient.put('/v1/organizations/companies', payload, { withAuth: true });

  return response.data;
}

/**
 * 수신자 거부 리스트 조회 API
 * - 로그인된 사용자만 접근 가능 (인증 필요)
 *
 * @param {Object} params
 * @param {number} params.company - 회사 코드
 * @param {number} params.teamCode - 팀 코드
 *
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export async function getRejectList({ company, teamCode }) {
  const response = await apiClient.get('/v1/organizations/reject/list', {
    params: { company, teamCode },
    withAuth: true,
  });

  return response.data;
}
